module.exports = __webpack_public_path__ + "9993a321928e7dd4b552c54ee8918658.svg";